import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = ["input", "preview"];

  connect() {
    if (this.inputTarget.files?.length) this.preview();
  }

  disconnect() {
    this.revokePreview();
  }

  preview() {
    const file = this.inputTarget.files?.[0];
    if (!file) return;

    this.revokePreview();
    this.objectUrl = URL.createObjectURL(file);
    const image = document.createElement("img");
    image.src = this.objectUrl;
    image.alt = "";
    this.previewTarget.replaceChildren(image);
  }

  revokePreview() {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
    this.objectUrl = null;
  }
}
